// Team Admin i18n — release detail (player, QC, reviewer actions, shortcuts) + activity labels.
const en = {
  "admin.rd.back": "Back to queue",
  "admin.rd.dspSummary": "DSP summary",
  "admin.rd.changeStatus": "Change status",
  "admin.rd.moreActions": "More actions",
  "admin.rd.exportMetadata": "Export metadata (JSON)",
  "admin.rd.editAll": "Edit all",
  "admin.rd.copied": "{label} copied to clipboard",
  "admin.rd.player.play": "Play",
  "admin.rd.player.pause": "Pause",
  "admin.rd.player.seek": "Seek",
  "admin.rd.player.volume": "Volume",
  "admin.rd.player.mute": "Mute",
  "admin.rd.player.unmute": "Unmute",
  "admin.rd.player.noAudio": "No audio file uploaded",
  "admin.rd.player.error": "Audio couldn't be loaded",
  "admin.rd.qc.title": "QC checklist",
  "admin.rd.qc.note": "Automatic checks from submitted metadata — always listen before approving.",
  "admin.rd.qc.coverMissing": "Cover art is missing",
  "admin.rd.qc.coverOk": "Cover art {w}×{h}, square",
  "admin.rd.qc.coverNotSquare": "Cover art is not square ({w}×{h})",
  "admin.rd.qc.coverSmall": "Cover art below 3000×3000 ({w}×{h})",
  "admin.rd.qc.coverUnknown": "Cover resolution unknown — check manually",
  "admin.rd.qc.metaMissing": "Missing metadata: {fields}",
  "admin.rd.qc.metaOk": "Title, artist, genre, language and date set",
  "admin.rd.qc.titleStyle": "{n} track title(s) contain “feat.” or ALL CAPS — DSP style guides reject these",
  "admin.rd.qc.datePast": "Release date is in the past",
  "admin.rd.qc.dateSoon": "Release date is less than 7 days away",
  "admin.rd.qc.explicitMissing": "Explicit flag not set on {n} track(s)",
  "admin.rd.qc.explicitOk": "Explicit flag set on all tracks",
  "admin.rd.qc.creditsMissing": "Credits missing — writers: {w} track(s), producers: {p} track(s)",
  "admin.rd.qc.creditsOk": "Songwriter and producer credits present",
  "admin.rd.qc.audioMissing": "{n} track(s) have no audio file",
  "admin.rd.qc.audioLossy": "{n} track(s) are not lossless (WAV/FLAC)",
  "admin.rd.qc.audioLowSpec": "{n} track(s) below 16-bit / 44.1 kHz",
  "admin.rd.qc.audioOk": "Audio meets 16-bit / 44.1 kHz minimum",
  "admin.rd.qc.audioLossless": "Lossless audio files (specs not reported)",
  "admin.rd.qc.isrcPending": "{n} track(s) without ISRC — will need codes",
  "admin.rd.qc.isrcOk": "ISRC present on all tracks",
  "admin.rd.qc.upcOk": "UPC assigned",
  "admin.rd.qc.upcPending": "No UPC yet",
  "admin.rd.qc.licensed": "Contains licensed content — verify license document",
  "admin.rd.qc.aiGenerated": "Marked as AI-generated — check DSP policies",
  "admin.rd.action.approve": "Approve",
  "admin.rd.action.requestEdits": "Request edits",
  "admin.rd.action.reject": "Reject",
  "admin.rd.action.prev": "Previous in queue",
  "admin.rd.action.next": "Next in queue",
  "admin.rd.action.inQueue": "{n} in queue",
  "admin.rd.action.rejectTitle": "Reject release",
  "admin.rd.action.editsTitle": "Request edits",
  "admin.rd.action.reasonDesc": "Pick a template or write a reason. The artist receives it by notification and email.",
  "admin.rd.action.reasonPlaceholder": "Reason sent to the artist…",
  "admin.rd.action.reasonRequired": "A reason is required.",
  "admin.rd.action.failed": "Status update failed",
  "admin.rd.action.alreadyApproved": "This release is already approved",
  "admin.rd.action.done.approved": "Release approved",
  "admin.rd.action.done.needs_edits": "Edits requested",
  "admin.rd.action.done.rejected": "Release rejected",
  "admin.rd.shortcuts.title": "Keyboard shortcuts",
  "admin.rd.shortcuts.approve": "Approve",
  "admin.rd.shortcuts.edits": "Request edits",
  "admin.rd.shortcuts.reject": "Reject",
  "admin.rd.shortcuts.next": "Next release in queue",
  "admin.rd.shortcuts.prev": "Previous release in queue",
  "admin.rd.shortcuts.play": "Play / pause current track",
  "admin.rd.shortcuts.help": "Show this help",
  "admin.rd.shortcuts.palette": "Command palette",
  "admin.rd.tpl.copyright_issue": "Copyright issue",
  "admin.rd.tpl.quality_issue": "Audio quality",
  "admin.rd.tpl.metadata_error": "Metadata error",
  "admin.rd.tpl.cover_art_issue": "Cover art",
  "admin.rd.tpl.duplicate_content": "Duplicate",
  "admin.rd.tpl.content_policy": "Content policy",
  "admin.rd.tpl.fix_metadata": "Fix metadata",
  "admin.rd.tpl.fix_cover_art": "Fix cover art",
  "admin.rd.tpl.fix_audio_quality": "Fix audio quality",
  "admin.rd.tpl.add_isrc": "Add ISRC",
  "admin.rd.tpl.verify_rights": "Verify rights",
  "admin.rd.tpl.fix_explicit_flag": "Fix explicit flag",
  "admin.action.release_approved": "Release approved",
  "admin.action.release_rejected": "Release rejected",
  "admin.action.release_needs_edits": "Edits requested",
  "admin.action.release_live": "Release set live",
  "admin.action.release_submitted": "Release submitted",
  "admin.action.release_taken_down": "Release taken down",
  "admin.action.user_registered": "New artist registered",
  "admin.action.user_status_approved": "Artist approved",
  "admin.action.user_status_rejected": "Artist rejected",
  "admin.action.user_status_suspended_license": "Artist suspended",
  "admin.action.payout_paid": "Payout marked paid",
  "admin.action.payout_approved": "Payout approved",
  "admin.action.payout_rejected": "Payout rejected",
};

const tr = {
  "admin.rd.back": "Kuyruğa dön",
  "admin.rd.dspSummary": "DSP özeti",
  "admin.rd.changeStatus": "Durumu değiştir",
  "admin.rd.moreActions": "Diğer işlemler",
  "admin.rd.exportMetadata": "Metadata dışa aktar (JSON)",
  "admin.rd.editAll": "Tümünü düzenle",
  "admin.rd.copied": "{label} panoya kopyalandı",
  "admin.rd.player.play": "Oynat",
  "admin.rd.player.pause": "Duraklat",
  "admin.rd.player.seek": "İlerlet",
  "admin.rd.player.volume": "Ses",
  "admin.rd.player.mute": "Sesi kapat",
  "admin.rd.player.unmute": "Sesi aç",
  "admin.rd.player.noAudio": "Ses dosyası yüklenmemiş",
  "admin.rd.player.error": "Ses yüklenemedi",
  "admin.rd.qc.title": "Kalite kontrol listesi",
  "admin.rd.qc.note": "Gönderilen metadata'dan otomatik kontroller — onaylamadan önce mutlaka dinle.",
  "admin.rd.qc.coverMissing": "Kapak görseli yok",
  "admin.rd.qc.coverOk": "Kapak {w}×{h}, kare",
  "admin.rd.qc.coverNotSquare": "Kapak kare değil ({w}×{h})",
  "admin.rd.qc.coverSmall": "Kapak 3000×3000'in altında ({w}×{h})",
  "admin.rd.qc.coverUnknown": "Kapak çözünürlüğü bilinmiyor — elle kontrol et",
  "admin.rd.qc.metaMissing": "Eksik metadata: {fields}",
  "admin.rd.qc.metaOk": "Başlık, sanatçı, tür, dil ve tarih girilmiş",
  "admin.rd.qc.titleStyle": "{n} parça başlığında “feat.” veya TAMAMI BÜYÜK HARF var — DSP kuralları bunu reddeder",
  "admin.rd.qc.datePast": "Yayın tarihi geçmişte",
  "admin.rd.qc.dateSoon": "Yayın tarihine 7 günden az var",
  "admin.rd.qc.explicitMissing": "{n} parçada müstehcenlik işareti yok",
  "admin.rd.qc.explicitOk": "Tüm parçalarda müstehcenlik işareti var",
  "admin.rd.qc.creditsMissing": "Eksik krediler — söz/beste: {w} parça, prodüktör: {p} parça",
  "admin.rd.qc.creditsOk": "Söz yazarı ve prodüktör kredileri mevcut",
  "admin.rd.qc.audioMissing": "{n} parçanın ses dosyası yok",
  "admin.rd.qc.audioLossy": "{n} parça kayıpsız değil (WAV/FLAC)",
  "admin.rd.qc.audioLowSpec": "{n} parça 16-bit / 44.1 kHz altında",
  "admin.rd.qc.audioOk": "Ses 16-bit / 44.1 kHz minimumunu karşılıyor",
  "admin.rd.qc.audioLossless": "Kayıpsız ses dosyaları (teknik bilgi yok)",
  "admin.rd.qc.isrcPending": "{n} parçada ISRC yok — kod gerekecek",
  "admin.rd.qc.isrcOk": "Tüm parçalarda ISRC var",
  "admin.rd.qc.upcOk": "UPC atanmış",
  "admin.rd.qc.upcPending": "Henüz UPC yok",
  "admin.rd.qc.licensed": "Lisanslı içerik var — lisans belgesini doğrula",
  "admin.rd.qc.aiGenerated": "Yapay zekâ ile üretildi olarak işaretli — DSP politikalarını kontrol et",
  "admin.rd.action.approve": "Onayla",
  "admin.rd.action.requestEdits": "Düzenleme iste",
  "admin.rd.action.reject": "Reddet",
  "admin.rd.action.prev": "Kuyrukta önceki",
  "admin.rd.action.next": "Kuyrukta sonraki",
  "admin.rd.action.inQueue": "Kuyrukta {n}",
  "admin.rd.action.rejectTitle": "Yayını reddet",
  "admin.rd.action.editsTitle": "Düzenleme iste",
  "admin.rd.action.reasonDesc": "Bir şablon seç veya sebep yaz. Sanatçıya bildirim ve e-posta ile iletilir.",
  "admin.rd.action.reasonPlaceholder": "Sanatçıya gönderilecek sebep…",
  "admin.rd.action.reasonRequired": "Sebep zorunludur.",
  "admin.rd.action.failed": "Durum güncellenemedi",
  "admin.rd.action.alreadyApproved": "Bu yayın zaten onaylı",
  "admin.rd.action.done.approved": "Yayın onaylandı",
  "admin.rd.action.done.needs_edits": "Düzenleme istendi",
  "admin.rd.action.done.rejected": "Yayın reddedildi",
  "admin.rd.shortcuts.title": "Klavye kısayolları",
  "admin.rd.shortcuts.approve": "Onayla",
  "admin.rd.shortcuts.edits": "Düzenleme iste",
  "admin.rd.shortcuts.reject": "Reddet",
  "admin.rd.shortcuts.next": "Kuyruktaki sonraki yayın",
  "admin.rd.shortcuts.prev": "Kuyruktaki önceki yayın",
  "admin.rd.shortcuts.play": "Geçerli parçayı oynat / duraklat",
  "admin.rd.shortcuts.help": "Bu yardımı göster",
  "admin.rd.shortcuts.palette": "Komut paleti",
  "admin.rd.tpl.copyright_issue": "Telif sorunu",
  "admin.rd.tpl.quality_issue": "Ses kalitesi",
  "admin.rd.tpl.metadata_error": "Metadata hatası",
  "admin.rd.tpl.cover_art_issue": "Kapak görseli",
  "admin.rd.tpl.duplicate_content": "Mükerrer içerik",
  "admin.rd.tpl.content_policy": "İçerik politikası",
  "admin.rd.tpl.fix_metadata": "Metadata düzelt",
  "admin.rd.tpl.fix_cover_art": "Kapağı düzelt",
  "admin.rd.tpl.fix_audio_quality": "Ses kalitesini düzelt",
  "admin.rd.tpl.add_isrc": "ISRC ekle",
  "admin.rd.tpl.verify_rights": "Hakları doğrula",
  "admin.rd.tpl.fix_explicit_flag": "Müstehcenlik işaretini düzelt",
  "admin.action.release_approved": "Yayın onaylandı",
  "admin.action.release_rejected": "Yayın reddedildi",
  "admin.action.release_needs_edits": "Düzenleme istendi",
  "admin.action.release_live": "Yayın aktif edildi",
  "admin.action.release_submitted": "Yayın gönderildi",
  "admin.action.release_taken_down": "Yayın kaldırıldı",
  "admin.action.user_registered": "Yeni sanatçı kaydoldu",
  "admin.action.user_status_approved": "Sanatçı onaylandı",
  "admin.action.user_status_rejected": "Sanatçı reddedildi",
  "admin.action.user_status_suspended_license": "Sanatçı askıya alındı",
  "admin.action.payout_paid": "Ödeme yapıldı olarak işaretlendi",
  "admin.action.payout_approved": "Ödeme onaylandı",
  "admin.action.payout_rejected": "Ödeme reddedildi",
};

const es = {
  "admin.rd.back": "Volver a la cola",
  "admin.rd.dspSummary": "Resumen DSP",
  "admin.rd.changeStatus": "Cambiar estado",
  "admin.rd.moreActions": "Más acciones",
  "admin.rd.exportMetadata": "Exportar metadatos (JSON)",
  "admin.rd.editAll": "Editar todo",
  "admin.rd.copied": "{label} copiado al portapapeles",
  "admin.rd.player.play": "Reproducir",
  "admin.rd.player.pause": "Pausar",
  "admin.rd.player.seek": "Buscar",
  "admin.rd.player.volume": "Volumen",
  "admin.rd.player.mute": "Silenciar",
  "admin.rd.player.unmute": "Activar sonido",
  "admin.rd.player.noAudio": "No se subió archivo de audio",
  "admin.rd.player.error": "No se pudo cargar el audio",
  "admin.rd.qc.title": "Lista de control de calidad",
  "admin.rd.qc.note": "Comprobaciones automáticas de los metadatos enviados — escucha siempre antes de aprobar.",
  "admin.rd.qc.coverMissing": "Falta la portada",
  "admin.rd.qc.coverOk": "Portada {w}×{h}, cuadrada",
  "admin.rd.qc.coverNotSquare": "La portada no es cuadrada ({w}×{h})",
  "admin.rd.qc.coverSmall": "Portada inferior a 3000×3000 ({w}×{h})",
  "admin.rd.qc.coverUnknown": "Resolución de portada desconocida — revisar manualmente",
  "admin.rd.qc.metaMissing": "Metadatos faltantes: {fields}",
  "admin.rd.qc.metaOk": "Título, artista, género, idioma y fecha definidos",
  "admin.rd.qc.titleStyle": "{n} título(s) contienen “feat.” o MAYÚSCULAS — las guías DSP los rechazan",
  "admin.rd.qc.datePast": "La fecha de lanzamiento ya pasó",
  "admin.rd.qc.dateSoon": "Faltan menos de 7 días para el lanzamiento",
  "admin.rd.qc.explicitMissing": "Indicador explícito sin definir en {n} pista(s)",
  "admin.rd.qc.explicitOk": "Indicador explícito definido en todas las pistas",
  "admin.rd.qc.creditsMissing": "Faltan créditos — autores: {w} pista(s), productores: {p} pista(s)",
  "admin.rd.qc.creditsOk": "Créditos de autores y productores presentes",
  "admin.rd.qc.audioMissing": "{n} pista(s) sin archivo de audio",
  "admin.rd.qc.audioLossy": "{n} pista(s) no son sin pérdida (WAV/FLAC)",
  "admin.rd.qc.audioLowSpec": "{n} pista(s) por debajo de 16 bits / 44,1 kHz",
  "admin.rd.qc.audioOk": "El audio cumple el mínimo de 16 bits / 44,1 kHz",
  "admin.rd.qc.audioLossless": "Archivos sin pérdida (especificaciones no informadas)",
  "admin.rd.qc.isrcPending": "{n} pista(s) sin ISRC — necesitarán códigos",
  "admin.rd.qc.isrcOk": "ISRC en todas las pistas",
  "admin.rd.qc.upcOk": "UPC asignado",
  "admin.rd.qc.upcPending": "Aún sin UPC",
  "admin.rd.qc.licensed": "Contiene contenido licenciado — verificar documento de licencia",
  "admin.rd.qc.aiGenerated": "Marcado como generado por IA — revisar políticas DSP",
  "admin.rd.action.approve": "Aprobar",
  "admin.rd.action.requestEdits": "Solicitar cambios",
  "admin.rd.action.reject": "Rechazar",
  "admin.rd.action.prev": "Anterior en la cola",
  "admin.rd.action.next": "Siguiente en la cola",
  "admin.rd.action.inQueue": "{n} en cola",
  "admin.rd.action.rejectTitle": "Rechazar lanzamiento",
  "admin.rd.action.editsTitle": "Solicitar cambios",
  "admin.rd.action.reasonDesc": "Elige una plantilla o escribe un motivo. El artista lo recibe por notificación y email.",
  "admin.rd.action.reasonPlaceholder": "Motivo enviado al artista…",
  "admin.rd.action.reasonRequired": "El motivo es obligatorio.",
  "admin.rd.action.failed": "No se pudo actualizar el estado",
  "admin.rd.action.alreadyApproved": "Este lanzamiento ya está aprobado",
  "admin.rd.action.done.approved": "Lanzamiento aprobado",
  "admin.rd.action.done.needs_edits": "Cambios solicitados",
  "admin.rd.action.done.rejected": "Lanzamiento rechazado",
  "admin.rd.shortcuts.title": "Atajos de teclado",
  "admin.rd.shortcuts.approve": "Aprobar",
  "admin.rd.shortcuts.edits": "Solicitar cambios",
  "admin.rd.shortcuts.reject": "Rechazar",
  "admin.rd.shortcuts.next": "Siguiente lanzamiento en la cola",
  "admin.rd.shortcuts.prev": "Lanzamiento anterior en la cola",
  "admin.rd.shortcuts.play": "Reproducir / pausar pista actual",
  "admin.rd.shortcuts.help": "Mostrar esta ayuda",
  "admin.rd.shortcuts.palette": "Paleta de comandos",
  "admin.rd.tpl.copyright_issue": "Derechos de autor",
  "admin.rd.tpl.quality_issue": "Calidad de audio",
  "admin.rd.tpl.metadata_error": "Error de metadatos",
  "admin.rd.tpl.cover_art_issue": "Portada",
  "admin.rd.tpl.duplicate_content": "Duplicado",
  "admin.rd.tpl.content_policy": "Política de contenido",
  "admin.rd.tpl.fix_metadata": "Corregir metadatos",
  "admin.rd.tpl.fix_cover_art": "Corregir portada",
  "admin.rd.tpl.fix_audio_quality": "Corregir calidad de audio",
  "admin.rd.tpl.add_isrc": "Añadir ISRC",
  "admin.rd.tpl.verify_rights": "Verificar derechos",
  "admin.rd.tpl.fix_explicit_flag": "Corregir indicador explícito",
  "admin.action.release_approved": "Lanzamiento aprobado",
  "admin.action.release_rejected": "Lanzamiento rechazado",
  "admin.action.release_needs_edits": "Cambios solicitados",
  "admin.action.release_live": "Lanzamiento publicado",
  "admin.action.release_submitted": "Lanzamiento enviado",
  "admin.action.release_taken_down": "Lanzamiento retirado",
  "admin.action.user_registered": "Nuevo artista registrado",
  "admin.action.user_status_approved": "Artista aprobado",
  "admin.action.user_status_rejected": "Artista rechazado",
  "admin.action.user_status_suspended_license": "Artista suspendido",
  "admin.action.payout_paid": "Pago marcado como pagado",
  "admin.action.payout_approved": "Pago aprobado",
  "admin.action.payout_rejected": "Pago rechazado",
};

export default { en, tr, es };
